import React from 'react';

const WelcomePage = React.lazy(() => import('./views/pages/welcome/Welcome'));
const InfoPaymentPage = React.lazy(() => import('./views/pages/payment/InfoPayment'));
const BillPaymentPage = React.lazy(() => import('./views/pages/payment/BillPayment'));
const SearchSchoolPage = React.lazy(() => import('./views/pages/searchschool/SearchSchool'));
const FeesPaymentPage = React.lazy(() => import('./views/pages/feespayment/FeesPayment'));

const routes = [
  // { path: '/', exact: true, name: 'Home' },
  { path: '/', exact: true, name: 'Welcome', component:  WelcomePage },
  { path: '/payment', exact: true, name: 'Info Paiement', component:  InfoPaymentPage },
  { path: '/payment/:transactionid', exact: true, name: 'Facture Paiement', component:  BillPaymentPage },
  { path: '/school', exact: true, name: 'Établissement', component:  SearchSchoolPage },
  { path: '/productpay/:produit', exact: true, name: 'Paiemnt produit', component:  FeesPaymentPage },
  // { path: '/dashboard', name: 'Tableau de bord', component:  DashboardPage },
];

export default routes;
